module.exports = __webpack_public_path__ + "img/arrawblack.234d8bed.png";